import { useMemo } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { Button, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import DatePickerField from "../../Document-Management/filters/DatePickerField";
import { ATTACHMENT_TYPES, TYPICAL_DRAWING_STORAGE_DOCUMENTS } from "../../../Common/Constants";
import AutocompleteField from "../../Document-Management/filters/AutoCompleteField";
import { getParsedLocalStorage } from "../../../Utils/storage-utils";
import { extractUserDataFromPermission } from "../../../Utils/Utils";
import { useParams } from "react-router-dom";

const DEFAULT_FILTER_VALUES: FieldValues = {
  from_ts: null,
  end_ts: null,
  user_name: "",
  document_name: "",
  user_role: "",
  remarks: "",
  document_type: [],
  section: [],
  station: [],
};

interface DocumentManagementFiltersProps {
  handleFilterChange: (value: any) => void;
}

const DocumentManagementFilters: React.FC<DocumentManagementFiltersProps> = ({ handleFilterChange }) => {
  const { register, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: DEFAULT_FILTER_VALUES,
  });

  const { station: customer_in_url } = useParams();

  // hide station filter if customer is present in URL
  const hide_customer_filter = Boolean(customer_in_url);

  function onSubmit(data: FieldValues) {
    // console.log("data", data);
    handleFilterChange(data);
  }
  function handleReset() {
    reset();
    handleFilterChange(DEFAULT_FILTER_VALUES);
  }

  const formValues = {
    document_type: watch("document_type"),
    from_ts: watch("from_ts"),
    end_ts: watch("end_ts"),
    section: watch("section"),
    station: watch("station"),
  };

  const user_permissions = useMemo(() => {
    const permissions = getParsedLocalStorage("permissions");
    const _permissions = extractUserDataFromPermission(permissions);
    const { innerKeysList: sectionList, customerList } = _permissions;
    return { sectionList, customerList };
  }, []);

  // console.log(user_permissions);

  return (
    <form className="flex items-center flex-wrap gap-2" onSubmit={handleSubmit(onSubmit)} onReset={handleReset}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePickerField
          maxDate={formValues.end_ts}
          value={formValues.from_ts}
          onChange={(value) => setValue("from_ts", value)}
          label="Uploading From Date"
        />
        <DatePickerField
          minDate={formValues.from_ts}
          value={formValues.end_ts}
          onChange={(value) => setValue("end_ts", value)}
          label="Uploading To Date"
        />
      </LocalizationProvider>
      {/* <TextField
        sx={{ flexGrow: 1, flexBasis: "15rem" }}
        label="User Name"
        size="small"
        placeholder="User Name"
        {...register("user_name")}
      /> */}
      <TextField
        sx={{ flexGrow: 1, flexBasis: "15rem" }}
        label="Drawing Name"
        size="small"
        placeholder="Drawing Name"
        {...register("document_name")}
      />

      <AutocompleteField
        id="document_type"
        watch={watch}
        options={TYPICAL_DRAWING_STORAGE_DOCUMENTS}
        label="Drawing Type"
        onChange={(value: any[]) => setValue("document_type", value)}
        sx={{ flexBasis: "15rem", flexGrow: 1 }}
        multiple
      />

      {/* <TextField
        sx={{ flexGrow: 1, flexBasis: "15rem" }}
        label="Remarks"
        size="small"
        placeholder="Remarks"
        {...register("remarks")}
      /> */}
      {/* <AutocompleteField
        id="division"
        watch={watch}
        options={["KGP", "CKP"]}
        label="Division"
        onChange={(value: any[]) => setValue("division", value)}
        sx={{ flexBasis: "15rem", flexGrow: 1 }}
      /> */}
      <AutocompleteField
        id="section"
        watch={watch}
        options={user_permissions.sectionList}
        label="Divisions"
        onChange={(value: any[]) => setValue("section", value)}
        sx={{ flexBasis: "15rem", flexGrow: 1 }}
        multiple
      />
      {/* {!hide_customer_filter && (
        <AutocompleteField
          id="station"
          watch={watch}
          options={user_permissions.customerList}
          label="Station"
          onChange={(value: any[]) => setValue("station", value)}
          sx={{ flexBasis: "15rem", flexGrow: 1 }}
          multiple
        />
      )} */}
      {/* <AutocompleteField
        id="document_type"
        watch={watch}
        options={ATTACHMENT_TYPES}
        label="Document Type"
        onChange={(value: any[]) => setValue("document_type", value)}
        sx={{ flexBasis: "15rem", flexGrow: 1 }}
        multiple
      /> */}
      <Button variant="outlined" type="reset">
        Reset
      </Button>
      <Button variant="contained" type="submit">
        Search
      </Button>
    </form>
  );
};

export default DocumentManagementFilters;
